import {
  FETCH_USER_REPORTS,
  FETCH_USER_REPORTS_SUCCESS,
  FETCH_USER_REPORTS_FAILED,
  SUBMIT_USER_REPORT,
  UPDATE_USER_REPORT,
} from '../store/types';

const INITIAL_STATE = {
  list: null,
  loading: false,
  error: { flag: false, msg: null },
};

export const userreportreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_USER_REPORTS:
      return { ...state, loading: true };
    case FETCH_USER_REPORTS_SUCCESS:
      return { ...state, list: action.payload, loading: false };
    case FETCH_USER_REPORTS_FAILED:
      return {
        ...state,
        list: null,
        loading: false,
        error: { flag: true, msg: action.payload },
      };
    case SUBMIT_USER_REPORT:
    case UPDATE_USER_REPORT:
      return state;
    default:
      return state;
  }
};
